const MESSAGEMEDIA = "mm";
const MULTITXT = "vodanz";
const DIRECTSMS = "directSMS";
const STREETDATA = "streetdata";
const WHOLESALESMS = "wholesale";
const TWO_DEGREES = "2degrees";
const SMSB = "smsb";
const MESSAGENET = "messagenet";
const MOBIPOST = "mobipost";
const SMSCENTRAL = "smscentral";
const ETXT = "etxt";
const TPGTELECOM = "tpgtelecom";
const SIMPLE_TEXTING = "simpletexting";
const MESSAGE_STUDIO = "messagestudio";
const SINCH_EU = "sincheu";
const APP_SINCH = "app-sinch";

export const getVendorChecks = () => ({
  isBrandAppSinch: window.VENDOR_LABEL === APP_SINCH,
  isBrandMM: window.VENDOR_LABEL === MESSAGEMEDIA,
  isBrandTPG: window.VENDOR_LABEL === TPGTELECOM,
  isBrandSMSC: window.VENDOR_LABEL === SMSCENTRAL,
  isBrandSMSB: window.VENDOR_LABEL === SMSB,
  isBrandWholeSale: window.VENDOR_LABEL === WHOLESALESMS,
  isBrandSimpleTexting: window.VENDOR_LABEL === SIMPLE_TEXTING,
  isNZCarriers:
    window.VENDOR_LABEL === ETXT ||
    window.VENDOR_LABEL === MULTITXT ||
    window.VENDOR_LABEL === TWO_DEGREES,
  isBrandMS: window.VENDOR_LABEL === MESSAGE_STUDIO,
  isBrandSE: window.VENDOR_LABEL === SINCH_EU,
  isBrandDirectSMS: window.VENDOR_LABEL === DIRECTSMS,
  isBrandMessageNet: window.VENDOR_LABEL === MESSAGENET,
  isBrandMobiPost: window.VENDOR_LABEL === MOBIPOST,
  isBrandStreetData: window.VENDOR_LABEL === STREETDATA,
});
